// extracted by mini-css-extract-plugin
export default {"videoContainer":"App_videoContainer__aB7Gm","loader":"App_loader__p8ESr","overLay":"App_overLay__PVK4d"};